module.exports = __webpack_public_path__ + "static/media/upload.a0b58329.svg";